import Vue from 'vue'
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//import routes
import LoginPage from './components/Login/LoginPage.vue'
import Dashboard from './components/Dashboard.vue'
import companyRoutes from './router/company';
import customerRoutes from './router/customer';
import invoiceRoutes from './router/invoice';
import userRoutes from './router/user';
import projectRoutes from './router/project';
import workinghourRoutes from './router/workinghour';


// Add routes to VueRouter
const router = new VueRouter({
  mode: 'history',
  routes: [
    { name: 'LoginPage', path: '/login', component: LoginPage },
    { name: 'Dashboard', path: '/', component: Dashboard },
    ...companyRoutes,
    ...customerRoutes,
    ...invoiceRoutes,
    ...userRoutes,
    ...projectRoutes,
    ...workinghourRoutes,
  ]
});

export default router
